<template>
  <atom-info-box>
    <p>Passwords must have:</p>

    <ul class="ecase-sign-in__form-password-policy-list">
      <li :class="getDisplayClasses(isMinimumEightCharacters)">
        a minimum length of 8 characters
      </li>
      <li :class="getDisplayClasses(hasAtLeastOneLowerCaseCharacter)">
        at least one lower-case letter
      </li>
      <li :class="getDisplayClasses(hasAtLeastOneUpperCaseCharacter)">
        at least one upper-case letter
      </li>
      <li :class="getDisplayClasses(hasAtLeastOneNumber)">
        at least one number
      </li>
      <li :class="getDisplayClasses(hasAtLeastOneSpecialCharacter)">
        at least one symbol (!@#$%^&amp;*()\-_=+{};:,&lt;.>)
      </li>
    </ul>
  </atom-info-box>
</template>

<script lang="ts">
import { useChangePasswordStore } from "authentication/js/composable/change-password.store";
import AtomInfoBox from "core/components/atom/infoBox/AtomInfoBox.vue";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  components: { AtomInfoBox },
  setup() {
    const changePasswordStore = useChangePasswordStore();

    const {
      password,
      passwordConfirmation,

      isMinimumEightCharacters,
      hasAtLeastOneLowerCaseCharacter,
      hasAtLeastOneUpperCaseCharacter,
      hasAtLeastOneNumber,
      hasAtLeastOneSpecialCharacter,
    } = storeToRefs(changePasswordStore);

    return {
      password,
      passwordConfirmation,

      isMinimumEightCharacters,
      hasAtLeastOneLowerCaseCharacter,
      hasAtLeastOneUpperCaseCharacter,
      hasAtLeastOneNumber,
      hasAtLeastOneSpecialCharacter,
    };
  },
  methods: {
    getDisplayClasses(rule: boolean) {
      return ["ecase-sign-in__form-password-policy-list-item", rule ? "ecase-sign-in__form-password-policy-list-item--valid" : ""];
    },
  },
});
</script>
